import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import GiftTemplateForm, { GiftTemplateFormData } from "../../../components/admin/giftTemplates/GiftTemplateForm";

export default function AdminAddGiftTemplatePage() {
  const navigate = useNavigate();
  const { giftCategoryId} = useParams<{ giftCategoryId: string}>();
  const numericgiftCategoryId = giftCategoryId ? parseInt(giftCategoryId) : 0;

    const [image,setImage] = useState<File|null>(null);
  

  const { register, handleSubmit, formState: { errors } ,watch} = useForm<GiftTemplateFormData>({
    defaultValues: {
    },
  });


   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: GiftTemplateFormData) => {
     if(!image){
        alert(t('upload_image_required'));
        return;
    }
    const formData = new FormData();
    formData.append("categoryId",numericgiftCategoryId.toString());
    if(data.startDate){
        formData.append('startDate',`${new Date( data.startDate).toISOString()}`)
    }
     if(data.endDate){
        formData.append('endDate',`${new Date( data.endDate).toISOString()}`)
    }
     if(image){
        formData.append('image',image)
    }
    updateResource(`gift-template`, formData,
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["gift-tepmpaltes-bycatgeory-by-admin"],
            navigateAfter: () => navigate(`/admin/gift-templates/${numericgiftCategoryId}`),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_gift_template" />
        <GiftTemplateForm register={register} errors={errors}  watch={watch} image={image} setImage={setImage}/>
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
